import { z } from "zod";

import { GlobalPaginationResponse, GlobalResponseSchema } from "./global-schema";

// Carrier Schema
export const CarrierBodySchema = z.object({
	carrier_id: z.number(),
	user_type: z.number(),
	is_self: z.boolean(),
});
export const CarrierFuelBodySchema = z.object({
	fuel_price_per_gallon: z.number().nullable(),
});
export const CarrierSchema = z.object({
	id: z.number(),
	title: z.string(),
	mc_number: z.string(),
});
const UserCarrierSchema = z.object({
	id: z.number(),
	user_id: z.string(),
	user_fullname: z.string(),
	carrier_id: z.number(),
	carrier_title: z.string(),
	user_type: z.number(),
	user_type_name: z.string(),
	request_status: z.number(),
	request_status_name: z.string(),
});
export const CarriersResponseSchema = GlobalPaginationResponse.extend({
	results: z.array(CarrierSchema),
});
export const UserCarriersResponseSchema = GlobalPaginationResponse.extend({
	results: z.array(CarrierSchema),
});
export const RequestCarriersResponseSchema = GlobalPaginationResponse.extend({
	results: z.array(UserCarrierSchema),
});
export const CarrierFuelPriceResponseSchema = GlobalResponseSchema.extend({
	data: CarrierFuelBodySchema,
});
